import { CampaignListSort } from '@/entities/campaign';
import { SearchInput } from '@/shared/components/search-input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/shadcn/select';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/shadcn/tabs';
import type { CampaignListFilter } from '../../hooks/use-campaigns-list';
import { statusConfigs } from '../campaign-detail/constants';

const sortOptions: Array<{
  value: CampaignListSort;
  label: string;
}> = [
  { value: CampaignListSort.START_DATE, label: 'Start date' },
  { value: CampaignListSort.ENDING_SOON, label: 'Ending date' },
];

export function CampaignStatusTabs({
  selectedFilter,
  onSelect,
}: {
  selectedFilter: CampaignListFilter;
  onSelect: (nextFilter: CampaignListFilter) => void;
}) {
  return (
    <Tabs value={selectedFilter} onValueChange={(value) => onSelect(value as CampaignListFilter)}>
      <TabsList className="grid w-full max-w-[420px] grid-cols-4">
        {statusConfigs.toArray().map((tab) => (
          <TabsTrigger key={tab.key} value={tab.key}>
            {tab.value.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}

export function SearchToolbar({
  searchQuery,
  onSearchQueryChange,
}: {
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
}) {
  return (
    <SearchInput
      className="max-w-[220px]"
      initialValue={searchQuery}
      onClear={() => onSearchQueryChange('')}
      onSubmit={onSearchQueryChange}
      placeholder="Search campaigns"
    />
  );
}

export function SortControl({
  sortOption,
  onSortOptionChange,
}: {
  sortOption: CampaignListSort;
  onSortOptionChange: (value: CampaignListSort) => void;
}) {
  return (
    <Select
      value={sortOption}
      onValueChange={(value) => onSortOptionChange(value as CampaignListSort)}
    >
      <SelectTrigger className="w-fit min-w-40">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {sortOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
